import React from 'react'

const TableHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <thead className="table-header">
      <tr className="table-header-row">{children}</tr>
    </thead>
  )
}

export default TableHeader
